var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormSelect',{attrs:{"name":_vm.name,"value":_vm.value,"disabled":_vm.disabled,"loading":_vm.loading,"required":_vm.required,"options":_vm.containerOptions,"pagination":{
    enabled: true,
    searchCallback: _vm.fetchSelectableContainers,
  }},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }